import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import DashboardTabbedSection from 'containers/Dashboard/components/dashboardSection/DashboardTabbedSection';
import DashboardSectionTab from 'containers/Dashboard/components/dashboardSection/DashboardSectionTab';

import { PlansTab } from './Plans';
import { SubscribersTab } from './Subscribers';
import { ChargesTab } from './Charges';

import __ from 'utils/i18n';
import './styles.scss';

const PLANS_TAB_INDEX = 0;

const RecurringPaymentsComponent = ({ history, location }) => {
  const [showReportsPanel, setShowReportsPanel] = useState(false);

  const handleNavigateToSubscribers = (plan) => {
    sessionStorage.setItem(
      'subscribersPlanFilter',
      JSON.stringify({ id: plan.planId, name: plan.name }),
    );
    
    const basePath = location.pathname.split('/recurring-payments')[0];
    history.push(`${basePath}/recurring-payments/subscribers`);
    
    requestAnimationFrame(() => {
      setTimeout(() => {
        const tabDivs = document.querySelectorAll('.dashboard-section-tab');
        const subscribersTab = Array.from(tabDivs).find(div => {
          const content = div.textContent || div.innerText;
          return content.toLowerCase().includes('suscriptor');
        });
        if (subscribersTab) {
          subscribersTab.click();
        }
      }, 200);
    });
  };

  const handleTabChange = () => {
    setShowReportsPanel(false);
  };

  const renderHeaderActions = (activeTabIndex) => {
    if (activeTabIndex !== PLANS_TAB_INDEX) return null;

    return (
      <Button
        className="buttom-radius recurring-payments-reports-tab-button"
        data-testid="merchant-reports-button"
        onClick={() => setShowReportsPanel(true)}
      >
        <i className="mdi mdi-file-document-outline mdi-24px mdi-left" />
        {__('dashboard.sections.recurringPayments.plans.actions.reports')}
      </Button>
    );
  };

  return (
    <DashboardTabbedSection
      className="recurring-payments"
      onTabChange={handleTabChange}
      renderHeaderActions={renderHeaderActions}
    >
      <DashboardSectionTab
        path="plans"
        title={__("dashboard.sections.recurringPayments.tabs.Plans")}
      >
        <PlansTab
          onNavigateToSubscribers={handleNavigateToSubscribers}
          showReportsPanel={showReportsPanel}
          onCloseReportsPanel={() => setShowReportsPanel(false)}
        />
      </DashboardSectionTab>
      <DashboardSectionTab
        path="subscribers"
        title={__("dashboard.sections.recurringPayments.tabs.Subscribers")}
      >
        <SubscribersTab />
      </DashboardSectionTab>
      <DashboardSectionTab
        path="charges"
        title={__("dashboard.sections.recurringPayments.tabs.Charges")}
      >
        <ChargesTab />
      </DashboardSectionTab>
    </DashboardTabbedSection>
  );
};

export const RecurringPayments = withRouter(RecurringPaymentsComponent);
